import React, { useState } from "react";
import { Container, Card, Row, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";

import { auth, useUser } from "../firebase";
import LoadingButton from "../components/LoadingButton";
import FormTextbox from "../components/FormTextbox";
import HeaderBar from "../components/HeaderBar";

const validationSchema = yup.object().shape({
  oldPassword: yup.string().required("Old Password is required"),
  password: yup
    .string()
    .required("New Password is required")
    .min(6, "Password must be at least 6 characters long"),
  confirmPassword: yup
    .string()
    .required("Confirm New Password is required")
    .test("passwords-match", "Passwords do not match", function(value) {
      return this.parent.password === value;
    })
});

const ChangePassword = ({ location }) => {
  const { user } = useUser();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const handleLogin = async (values, actions) => {
    try {
      const credential = auth.EmailAuthProvider.credential(
        user.email,
        values.oldPassword
      );
      await user.reauthenticateWithCredential(credential);
      await user.updatePassword(values.password);
      actions.setSubmitting(false);
      setSuccess(true);
    } catch (error) {
      switch (error.code) {
        case "auth/wrong-password":
          actions.setFieldError("oldPassword", error.message);
          break;
        case "auth/weak-password":
          actions.setFieldError("password", error.message);
          break;
        default:
          setError(error.message);
      }
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <HeaderBar heading="Change Password" />
      <Container>
        <Row className="justify-content-center mt-4">
          <Col md="4">
            <Card className="p-4">
              {success ? (
                <div className="alert alert-success">
                  Your password has been changed.
                </div>
              ) : (
                <>
                  {error && <div className="alert alert-danger">{error}</div>}
                  <Formik
                    initialValues={{
                      oldPassword: "",
                      password: "",
                      confirmPassword: ""
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleLogin}
                  >
                    {formik => (
                      <Form noValidate onSubmit={formik.handleSubmit}>
                        <FormTextbox
                          formik={formik}
                          controlId="oldPassword"
                          label="Old Password"
                          password
                        />
                        <FormTextbox
                          formik={formik}
                          controlId="password"
                          label="New Password"
                          password
                        />
                        <FormTextbox
                          formik={formik}
                          controlId="confirmPassword"
                          label="Confirm New Password"
                          password
                        />
                        <LoadingButton
                          isLoading={formik.isSubmitting}
                          variant="primary"
                          type="submit"
                          className="w-100"
                        >
                          Change Password
                        </LoadingButton>
                      </Form>
                    )}
                  </Formik>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ChangePassword;
